// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ApiGatewayPathBuilder, CloudFunctionsPathBuilder, Env, IConsumerEnvironment, envToProjectId, getEnvDomain } from 'shared-lib'

const env: Env = 'ci'
const projectId = envToProjectId[env]

const apiGatewayBuilder = new ApiGatewayPathBuilder(env)
const cloudFunctionsBuilder = new CloudFunctionsPathBuilder(env)

export const environment: IConsumerEnvironment = {
  production: false,
  env,
  firebaseConfig: {
    apiKey: 'AIzaSyAKw9ZecFlaFfaOQ5u6iXgLp2NeEFCgmoA',
    appId: '1:618126091641:web:bae7640271e2967b17bba8',
    authDomain: `${projectId}.firebaseapp.com`,
    measurementId: 'G-MM9BYDR3L6',
    messagingSenderId: '618126091641',
    projectId,
    storageBucket: `${env}-content.instockdepot.com`,
  },
  services: {
    auth: apiGatewayBuilder.build('auth'),
    cloudFunctions: cloudFunctionsBuilder.build(),
    commerce: apiGatewayBuilder.build('commerce'),
    content: apiGatewayBuilder.build('content'),
    customer: apiGatewayBuilder.build('customer'),
    events: apiGatewayBuilder.build('events'),
    files: apiGatewayBuilder.build('files'),
    integration: apiGatewayBuilder.build('integration'),
    messaging: apiGatewayBuilder.build('messaging'),
    notifications: apiGatewayBuilder.build('notifications'),
    product: apiGatewayBuilder.build('product'),
    productItem: apiGatewayBuilder.build('productItem'),
    registration: apiGatewayBuilder.build('registration'),
    seller: apiGatewayBuilder.build('seller'),
    user: apiGatewayBuilder.build('user'),
  },

  _business_EmailActionRoute: `https://${getEnvDomain(env, 'app.instockdepot.com')}/#/auth/actions`,
  algoliaAppId: 'T669KPJF0Q',
  algoliaSearchKey: 'ccb4068400a6c1e66dcb9dba0ad3452d',
  // We can turn authentication off in case we are using this application inside and SDK and do not want to have any authentication
  authentication: false, // Look to the auth guard for use of this value
  basePlatformHost: getEnvDomain(env, 'app.instockdepot.com'),
  cdnCname: getEnvDomain(env, 'content.instockdepot.com'),
  emailVerificationEmailTemplateId: '2LKYubs8e8JqMm17XrZW',
  passwordRecoveryEmailTemplateId: 'GQKsG5Wnv9sWJ9uY3aDf',
  stripePublishableKey: 'pk_test_51LLDaTHW4nrizR1iJ3St5EIgBAiFyyPBBIP5v1INixoA0jK713KXkyFmCAzQKXAJf9UsiR8s92AxdJwmDrgnYXw700i5NiYmrx',
  tenant: {
    appConfigBaseURL: `https://${getEnvDomain(env, 'content.instockdepot.com')}/assets/bootstrap`,
    defaultTenant: 'construction2.ci.instockdepot.app',
  },
  tenantId: 'construction-xkiyr',
  themesEnabled: true,
  v2ReCaptcha: '6LdwS4UrAAAAAAuU3D302tLOeP48X8jbtawseb6T',
  version: 'ab38bb4',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
